import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import {
  Control,
  Controller,
  FieldValues,
  Path,
  PathValue,
} from 'react-hook-form';

interface Props<T extends FieldValues> {
  items: { id: number; name: string }[];
  label: string;
  control: Control<T>;
  name: string;
  defaultValue?: number;
}

const AppSelectList = <T extends FieldValues>({
  items,
  label,
  control,
  name,
  defaultValue,
}: Props<T>) => {
  return (
    <FormControl fullWidth>
      <InputLabel>{label}</InputLabel>
      <Controller
        name={name as Path<T>}
        control={control}
        defaultValue={
          (defaultValue as PathValue<T, Path<T>>) ||
          (items[0]?.id as PathValue<T, Path<T>>)
        }
        render={({ field }) => (
          <Select {...field} label={label}>
            {items.map(({ id, name }) => (
              <MenuItem key={id} value={id}>
                {name}
              </MenuItem>
            ))}
          </Select>
        )}
      />
    </FormControl>
  );
};

export default AppSelectList;
